import React, { Component } from 'react';

class Modal extends Component {
	render() {
		return (
			<div className="modal">
			</div>
		);
	};
}

export default Modal;